<soft-page>
  <soft-page-header>
    <ng-container
      *ngTemplateOutlet="header()?.template() ?? null"
    ></ng-container>
  </soft-page-header>
  <ng-content></ng-content>
</soft-page>
